import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import {ServicesPage} from "../services/services";
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";
import moment from 'moment';
import {TabsServiceProvider} from "../../providers/tabs-service/tabs-service";

/**
 * Generated class for the AdvancedBookingsTimePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-advanced-bookings-time',
    templateUrl: 'advanced-bookings-time.html',
})
export class AdvancedBookingsTimePage {

    date: any;
    shop: any;
    barber: any;
    byStaff: boolean;
    guestUser: any = null;

    errors: {};
    loading: boolean;
    bookingTimes: any;
    periodsAm: any;
    periodsPm: any;
    numberOfPeriodsAvailable: number = 0;
    private fromLobby: boolean;

    constructor(public navCtrl: NavController, public navParams: NavParams, private http: HttpClient, private apiErrorHandler: ApiErrorHandlerProvider, private tabsService: TabsServiceProvider) {
        this.date = navParams.get('date');
        this.shop = navParams.get('shop');
        this.barber = navParams.get('barber');
        this.byStaff = navParams.get('byStaff');
        this.guestUser = navParams.get('guestUser');
        this.fromLobby = navParams.get('fromLobby') ? true : false;
        this.periodsAm = [];
        this.periodsPm = [];
    }

    ionViewDidLoad() {
        this.tabsService.hide();
        this.getAvailableBookingTimes();
    }

    getAvailableBookingTimes() {
        this.loading = true;

        this.http.post(`/check-advanced-booking-availability`, {
            bookingDate: this.date,
            bookingTime: 0,
            team: this.shop.id,
            teamMember: this.barber,
            termsAccepted: true,
            type: 2, // Advanced booking
            user: localStorage.getItem('tuid')
        }).subscribe((bookingTimes: any) => {
            this.bookingTimes = bookingTimes;
            this.loading = false;
        }, error => {
            this.loading = false;
            this.errors = this.apiErrorHandler.handleError(error);
        }, () => {
            this.getPeriods();
        })
    }

    getPeriods() {
        this.numberOfPeriodsAvailable = 0;
        for (let bookingTime of this.bookingTimes) {

            let afternoon = moment(bookingTime.date, 'YYYY-MM-DD HH:mm:ss.SSSS').format('YYYY-MM-DD') + ' 11:59:59.000000';
            let period: any = {};

            if (moment(bookingTime.date, 'YYYY-MM-DD HH:mm:ss.SSSS').isBefore((moment(afternoon, 'YYYY-MM-DD HH:mm:ss.SSSS')))) {
                period.bookingTime = moment(bookingTime.date, 'YYYY-MM-DD HH:mm:ss.SSSS').format('HH:mm');
                period.available = bookingTime.available;
                this.periodsAm.push(period);
            } else {
                period.bookingTime = moment(bookingTime.date, 'YYYY-MM-DD HH:mm:ss.SSSS').format('HH:mm');
                period.available = bookingTime.available;
                this.periodsPm.push(period);
            }

            // If the period is available increment by 1
            if (period.available === true){
              this.numberOfPeriodsAvailable++;
            }

        }
    }

    openServicePage(period) {
        if (period.available) {
            let requestedBookingDate = moment(this.date + ' ' + period.bookingTime, 'DD-MM-YYYY HH:mm');
            this.navCtrl.push(ServicesPage, {
                advancedBooking: {
                    date: this.date,
                    time: period.bookingTime,
                    requested_booking_date_string: requestedBookingDate.format('dddd Do MMMM YYYY') + ' at ' + requestedBookingDate.format('h:mm a')
                },
                shop: this.shop,
                barber: this.barber,
                bookingType: 2, // Advanced booking
                byStaff: this.byStaff,
                guestUser: this.guestUser,
                fromLobby: this.fromLobby
            });
        }
    }

    pop(){
      this.navCtrl.pop();
    }
}



// WEBPACK FOOTER //
// ./src/pages/advanced-bookings-time/advanced-bookings-time.ts